import { Suspense } from "react";
import { useRoutes, Navigate } from "react-router-dom";
import { FullPageLoader, LoginPage } from "@livingsyncs/ui";
import { PrivateRoute } from "./components/PrivateRoute";
import { PortalBoundary } from "./components/PortalBoundary";
import { buildRouteTree } from "./router/buildRouteTree";
import { appPortal } from "./router/portals/app.portal";
// Eager: unauthenticated entry pages (kept out of the lazy portal chunks).
import { AcceptInvitationPage } from "./pages/AcceptInvitationPage";
import { NoAccessPage } from "./pages/NoAccessPage";

// US-044, corrected for the frontend split epic (Phase 7, Task 7.1): admin
// and audit are no longer portals THIS app hosts — apps/admin and
// apps/auditor exist as their own apps now, admin.portal.ts/audit.portal.ts
// deleted from here. Only appPortal remains.
const PORTALS = [appPortal];

export function AppRoutes() {
  return useRoutes([
    { path: "/login", element: <LoginPage ownPortal="app" /> },
    { path: "/accept-invitation", element: <AcceptInvitationPage /> },
    {
      path: "/no-access",
      element: (
        <PrivateRoute>
          <NoAccessPage />
        </PrivateRoute>
      ),
    },
    ...PORTALS.map((portal) => {
      const Layout = portal.layout;
      return {
        path: portal.basePath,
        element: (
          <PrivateRoute>
            <PortalBoundary portal={portal.id} />
          </PrivateRoute>
        ),
        children: [
          {
            element: (
              <Suspense fallback={<FullPageLoader />}>
                <Layout />
              </Suspense>
            ),
            children: buildRouteTree(portal.routes),
          },
        ],
      };
    }),
    // Catch-all — PrivateRoute on the portals handles auth; unknown paths go
    // to login.
    { path: "*", element: <Navigate to="/login" replace /> },
  ]);
}
